// รายการธนาคาร/ช่องทางรับเงินสำหรับ dropdown — ใช้ร่วมกันในฟอร์มลูกค้า (CustomerForm.js) และฟอร์มพนักงาน
// (EmployeeForm.js)
// value = ชื่อภาษาอังกฤษที่เก็บลงฐานข้อมูลเป็นข้อความตรงๆ (13 รายการแรกคงรูปแบบเดิมทุกตัวอักษร เพราะข้อมูลเก่า
// ถูกเก็บด้วยค่านี้แล้ว — แก้ value = ข้อมูลเก่าไม่ตรงรายการ) / label = ชื่อภาษาไทยที่โชว์ใน dropdown
// code = รหัสธนาคาร 3 หลักสำหรับไฟล์โอนเงิน (ใส่เฉพาะที่ยืนยันได้ — ไม่มี code = ว่าง ต้องตรวจก่อนใช้งานจริง)
// เพิ่มธนาคารใหม่ต่อท้ายเท่านั้น
const THAI_BANKS = [
  { value: 'Promptpay', label: 'พร้อมเพย์ (PromptPay)' },
  {
    value: 'Kasikornbank(KBank)',
    code: '004',
    label: 'ธนาคารกสิกรไทย (KBank)',
  },
  {
    value: 'Government Savings Bank(GSB)',
    code: '030',
    label: 'ธนาคารออมสิน (GSB)',
  },
  { value: 'Krungthai Bank(KTB)', code: '006', label: 'ธนาคารกรุงไทย (KTB)' },
  {
    value: 'Siam Commercial Bank(SCB)',
    code: '014',
    label: 'ธนาคารไทยพาณิชย์ (SCB)',
  },
  { value: 'Bangkok Bank(BBL)', code: '002', label: 'ธนาคารกรุงเทพ (BBL)' },
  {
    value: 'Bank of Ayudhya(BAY)',
    code: '025',
    label: 'ธนาคารกรุงศรีอยุธยา (BAY)',
  },
  {
    value: 'TMBThanachart Bank(TTB)',
    code: '011',
    label: 'ธนาคารทหารไทยธนชาต (TTB)',
  },
  {
    value: 'CIMB Thai Bank(CIMBT)',
    code: '022',
    label: 'ธนาคารซีไอเอ็มบี ไทย (CIMBT)',
  },
  {
    value: 'United Overseas Bank(UOB)',
    code: '024',
    label: 'ธนาคารยูโอบี (UOB)',
  },
  {
    value: 'Kiatnakin Phatra Bank(KKP)',
    code: '069',
    label: 'ธนาคารเกียรตินาคินภัทร (KKP)',
  },
  {
    value: 'Land and Houses Bank(LH Bank)',
    code: '073',
    label: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ (LH Bank)',
  },
  { value: 'Citibank N.A.', code: '017', label: 'ธนาคารซิตี้แบงก์ (Citibank)' },
  // ธนาคารรัฐ / สถาบันการเงินเฉพาะกิจ
  {
    value: 'Bank for Agriculture and Agricultural Cooperatives(BAAC)',
    code: '034',
    label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธ.ก.ส.)',
  },
  {
    value: 'Government Housing Bank(GHB)',
    code: '033',
    label: 'ธนาคารอาคารสงเคราะห์ (ธอส.)',
  },
  {
    value: 'Islamic Bank of Thailand(ISBT)',
    code: '066',
    label: 'ธนาคารอิสลามแห่งประเทศไทย (ISBT)',
  },
  // ธนาคารพาณิชย์ไทยอื่นๆ
  {
    value: 'Thai Credit Bank(TCRB)',
    code: '071',
    label: 'ธนาคารไทยเครดิต (TCRB)',
  },
  { value: 'Tisco Bank(TISCO)', code: '067', label: 'ธนาคารทิสโก้ (TISCO)' },
];

// ชื่อไทยของค่าที่เก็บไว้ — ถ้าไม่ตรงรายการ (ข้อมูลเก่าที่พิมพ์เอง) คืนค่าเดิมตามที่เก็บ
export const getBankLabel = (value) =>
  THAI_BANKS.find((b) => b.value === value)?.label || value;

// รหัสธนาคาร 3 หลักของค่าที่เก็บไว้ — ไม่รู้จัก/ไม่มี code คืนค่าว่าง
export const getBankCode = (value) =>
  THAI_BANKS.find((b) => b.value === value)?.code || '';

export default THAI_BANKS;
